angular.module('shared.filters.asUtc', []).filter('asUtc', function () {
    return (input) => {
        return input && !input?.toUpperCase().endsWith('Z')
            ? input + 'Z'
            : input;
    };
});
